import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EllipsesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Ellipses",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M4.8 13.2C3.25 13.2 2 14.45 2 16s1.25 2.8 2.8 2.8zm0 5.6c1.55 0 2.8-1.25 2.8-2.8s-1.25-2.8-2.8-2.8zM16 13.2c-1.55 0-2.8 1.25-2.8 2.8s1.25 2.8 2.8 2.8zm0 5.6c1.55 0 2.8-1.25 2.8-2.8s-1.25-2.8-2.8-2.8zm11.2-5.6c-1.55 0-2.8 1.25-2.8 2.8s1.25 2.8 2.8 2.8zm0 5.6c1.55 0 2.8-1.25 2.8-2.8s-1.25-2.8-2.8-2.8z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "27",
        cy: "16.14",
        r: "1.14"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "27",
        cy: "16.14",
        r: "2.29"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "15.57",
        cy: "16.14",
        r: "1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.57 18.43c-1.26 0-2.29-1.03-2.29-2.29s1.03-2.29 2.29-2.29 2.29 1.03 2.29 2.29-1.03 2.29-2.29 2.29m0-2.29"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "4.14",
        cy: "16.14",
        r: "1.14"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "4.14",
        cy: "16.14",
        r: "2.29"
      })]
    })
  }));
};
EllipsesIcon.displayName = 'EllipsesIcon';